import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=6c5a48b6"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=6c5a48b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports